<template>
    <div>
        <!-- Таблица тендеров -->
        <basic-table
            show-top-button="true"
            @top-button-click="openTenderModal('create')"
        >
            <template v-slot:table_cards_header>
                <h5>Tenders List</h5>
            </template>
            <template v-slot:table_rows_header>
                <tr class="border-bottom-primary">
                    <th scope="col">Id</th>
                    <th scope="col">Tender Name</th>
                    <th scope="col">Closing Date</th>
                    <th scope="col">GC Company</th>
                    <th scope="col">Actions</th>
                </tr>
            </template>
            <template v-slot:table_rows_data>
                <!-- Показать сообщение, если таблица пустая -->
                <tr v-if="tenders === null">
                    <td colspan="5" class="text-center">Table is empty</td>
                </tr>
                <!-- Вывод строки тендеров -->
                <tr v-else v-for="(tender, index) in tenders" :key="tender.id">
                    <td>{{ tender.id }}</td>
                    <td>{{ tender.tender_name }}</td>
                    <td>{{ tender.closing_date }}</td>
                    <td>{{ tender.gc_company.company_name }}</td>
                    <td>
                        <ul class="action">
                            <!-- Редактирование -->
                            <li class="edit">
                                <a
                                    href="#"
                                    @click="openTenderModal('edit', tender)"
                                >
                                    <i class="icon-pencil-alt"></i>
                                </a>
                            </li>
                            <!-- Удаление -->
                            <li class="delete">
                                <a
                                    @click="setTenderId(tender, index)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-modal"
                                    href="#"
                                >
                                    <i class="icon-trash"></i>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
            </template>
        </basic-table>

        <!-- Единое модальное окно для создания/редактирования тендера -->
        <tender-modal
            :mode="modalMode"
            :tender="selectedTender"
            target-id="tender-modal"
            @stored="fetchAll"
        />

        <!-- Модальное окно для удаления -->
        <basic-modal
            title="Delete Tender"
            target-id="delete-modal"
            :modal-body="deleteMessage"
        >
            <template v-slot:first_button>
                <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="deleteTender(this.deleteTenderIdRow)"
                >
                    Delete
                </button>
            </template>
        </basic-modal>
    </div>
</template>

<script>
import BasicTable from "../Basic/BasicTable.vue";
import BasicModal from "../Basic/BasicModal.vue";
import TenderModal from "./TenderModal.vue";

export default {
    name: "TendersList",
    components: {
        BasicTable,
        BasicModal,
        TenderModal,
    },
    data() {
        return {
            tenders: null,
            selectedTender: {}, // Данные выбранного тендера
            modalMode: "create", // Режим модального окна: create или edit
            deleteTenderIdRow: null, // ID тендера для удаления
            deleteMessage: '', // Сообщение подтверждения удаления тендера
        };
    },
    methods: {
        // Закрытие модального окна
        closeModal() {
            $('#tender-modal').modal('hide');
            this.fetchAll();
        },

        // Метод для открытия модального окна (создание/редактирование)
        openTenderModal(mode, tender = {}) {
            this.modalMode = mode;
            this.selectedTender = tender;
            $('#tender-modal').modal('show');
        },

        // Получение всех тендеров
        fetchAll() {
            axios.get('/api/tenders/fetch').then((response) => {
                this.tenders = response.data.items?.length ? response.data.items : null;
            });
        },

        // Установка ID тендера для удаления
        setTenderId(tender) {
            this.deleteTenderIdRow = tender.id;
            this.deleteMessage = `Are you sure you want to delete tender "${tender.tender_name}"?`;
        },

        // Удаление тендера
        deleteTender(tenderId) {
            axios
                .delete(`/api/tenders/${tenderId}`)
                .then(() => {
                    this.fetchAll();
                })
                .catch((error) => {
                    console.error('Error deleting tender:', error);
                });
        },
    },
    mounted() {
        this.fetchAll();
    },
};
</script>
